export default [
    {
        path: 'consulta-estoque',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-consulta-estoque' */ '@/views/imunizacao/consulta-estoque/Index'),
        redirect: 'consulta-estoque/index',
        children: [
            {
                name: 'imunizacao-consulta-estoque-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-consulta-estoque' */ '@/views/imunizacao/consulta-estoque/List.vue'),
            },
        ],
    },
]